
import { OwlCarousel } from 'ngx-owl-carousel';

export class Pager {
  private pageSize;
  public pages = [];
  public currentPage = 1;
  public carouselOption = {
    dots: false,
    navigation: false,
    nav: false,
    loop: false,
    lazyLoad: false,
    items: 1,
    // onDrag: this.owlDrag.bind(this)
  };
  constructor(pageSize) {
    this.pageSize = pageSize;
  }
  setData(data) {
    const temp = [];
    const tempData = JSON.parse(JSON.stringify(data));


    while (tempData.length) {
      temp.push(tempData.splice(0, this.pageSize));
    }
    this.pages = temp;
    this.currentPage = 1;
  }
  updateDataTrack(data) {
    this.pages.map((page) => {
      const currentTrack = page.filter(track => track.startTimestamp === data.startTimestamp)[0];
      if (currentTrack) {
        currentTrack.startAddress = data.startAddress;
        currentTrack.finishAddress = data.finishAddress;
      }
    });
  }

  nextSlide(element: OwlCarousel) {
    if (this.currentPage >= this.pages.length) {
      return;
    }
    this.currentPage++;
    element.to([this.currentPage - 1, 200]);
  }
  toFirstSlide(element: OwlCarousel) {
    if (element) {
      this.currentPage = 1;
      element.to([0, 200]);
    }

  }
  prevSlide(element: OwlCarousel) {
    if (this.currentPage < 2) {
      return;
    }
    this.currentPage--;
    element.to([this.currentPage - 1, 200]);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pager.ts